<template>
  <div :class="'calendarWrapper' + theme">
    <span :class="'leftButton' + theme">
      <span class="icon-toggle"  @click="calendarMonthPrevious()" title="Prev">
     </span>
    </span>
    <span :class="'rightButton' + theme">
       <span class="icon-play-24" @click="calendarMonthNext()" title="Next"></span>
    </span>
    <div class="ui-datepicker-title">
      <select
        ref="monthPicker"
        class="ui-datepicker-month"
        style="width:78.94px; float:left;margin-left:17px;margin-top:-7px"
        @change="onMonthChange($event)">
        <option value="0">Jan</option>
        <option value="1">Feb</option>
        <option value="2">Mar</option>
        <option value="3">Apr</option>
        <option value="4">May</option>
        <option value="5">Jun</option>
        <option value="6">Jul</option>
        <option value="7">Aug</option>
        <option value="8">Sep</option>
        <option value="9">Oct</option>
        <option value="10">Nov</option>
        <option value="11">Dec</option>
        </select>
      <select
        ref="yearPicker"
        class="ui-datepicker-year"
        style="width:78.94px;float:right;margin-right:20px;margin-top:-7px"
        @change="onYearChange($event)"
      >
      </select>
    </div>
   <v-sheet height="190" width="271">
      <v-calendar        
        @click:date="setDate($event)"
        style="padding-top:5px;border-radius:3px;"
        ref="calendar"
        v-model="value"
      ></v-calendar>
    </v-sheet> 
    <div style="margin-top:35px" v-if="showYesterdayTodayButtons">
      <span style="float:left;margin-left:5px"
        ><ps-button type="button" :click="setDateToYesterday"
          >Yesterday</ps-button
        ></span
      >
      <span style="float:right;margin-right:5px"
        ><ps-button type="button" :click="setDateToToday"
          >Today</ps-button
        ></span
      >
    </div>
  </div>

</template>

<script>

export default {
  name: "PsCalendar",
  data() {
    return {
      value: "",
      todaysDate: new Date()
    };
  },
  props: {
        active: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default:"Blue"
      },
    showFuture: {
      type: Boolean,
      default: false,
    },
    showYesterdayTodayButtons: {
      type: Boolean,
      default: true,
    },
    yearsForward: {
      type: Number,
      default: 5,
    },
    yearsBack: {
      type: Number,
      default: 5,
    },
  },
  watch: {
    value: function(val) {
      var currentDate = new Date(this.value + "T12:00:00-06:30");
      this.$refs.monthPicker.selectedIndex = currentDate.getMonth();

      this.updateYearPicker();

      var year = this.value.substring(0, 4);
      for (var i = 0, j = this.$refs.yearPicker.options.length; i < j; ++i) {
        if (this.$refs.yearPicker.options[i].innerHTML === year) {
          this.$refs.yearPicker.selectedIndex = i;
          break;
        }
      }

      var valYear = val.split("-")[0];
      var valMonth = val.split("-")[1];

      var gDate = this.getCurrentGDate();
      var gYear = gDate.split("-")[0];
      var gMonth = gDate.split("-")[1];

      if (valYear + valMonth !== gYear + gMonth) {
        this.$nextTick(function() {
          var elem = document.getElementsByClassName(
            "v-calendar-weekly__day v-present"
          )[0];
          if (typeof elem !== "undefined") elem.classList.remove("v-present");
        });
      } else {
        this.$nextTick(function() {
          var elem = document.getElementsByClassName(
            "v-calendar-weekly__day v-present"
          )[0];
          if (typeof elem !== "undefined") elem.classList.remove("v-present");

          var day = gDate.split("-")[2];
          if (day[0] === "0") {
            day = day.substring(1, 2);
          }
          var elems = document.getElementsByClassName("v-calendar-weekly__day");

          for (var i = 0; i < elems.length; i++) {
            if(elems.item(i).classList.contains("v-outside"))
              continue;
            if (
              elems.item(i).innerText === day &&
              elems.item(i).innerText.length === day.length
            ) {
              elems.item(i).classList.add("v-present");
            }
            var selectedMonth = this.$refs.monthPicker[
              this.$refs.monthPicker.value
            ].innerText;
            var selectedDate = elems.item(i).innerText;

            if (selectedMonth.toString() + " " + day === selectedDate) {
              elems.item(i).classList.add("v-present");
            }
          }
        });
      }

      if(this.$refs.monthPicker.value.toString() === this.todaysDate.getMonth().toString()) {
        this.$nextTick(function() {
          var elems = document.getElementsByClassName("v-calendar-weekly__day");

          for (var i = 0; i < elems.length; i++) {
            if(elems.item(i).classList.contains("v-outside"))
              continue;
            if(elems.item(i).innerText === this.todaysDate.getDate().toString()) {
              elems.item(i).classList.remove("v-present");
              elems.item(i).classList.add("v-present-today");
            }
          }
  
        });
      } else { 
        this.$nextTick(function() {
          var elems = document.getElementsByClassName("v-calendar-weekly__day");

          for (var i = 0; i < elems.length; i++) {
            if(!(elems.item(i).classList.contains("v-outside")))
              continue;
            if(elems.item(i).innerText === this.todaysDate.getDate().toString()) {
                   elems.item(i).classList.remove("v-present");
              elems.item(i).classList.add("v-present-today");
            }
          }
        });
      }

      if(this.$props.showFuture === false) {
        // disable all future dates if we are on today's month.
        var today = new Date();
        var todaysMonth = today.getMonth();
        var todaysDay = today.getDate();
        
        if(this.$refs.monthPicker.value.toString() === todaysMonth.toString())
        {
          // disable all future days buttons after todays day.
          this.$nextTick(function() {
          var elems = document.getElementsByClassName("v-calendar-weekly__day");

          for (var i = 0; i < elems.length; i++) {
            if(parseInt(elems.item(i).innerText) > todaysDay && (!elems.item(i).classList.contains("v-past"))) {
               elems.item(i).getElementsByTagName("button")[0].setAttribute("disabled","");
               elems.item(i).classList.add("disabledDay");
               elems.item(i).getElementsByTagName("button")[0].classList.add("disabledDay");
            }

            if(elems.item(i).classList.contains("v-future")) {
               elems.item(i).getElementsByTagName("button")[0].setAttribute("disabled","");
               elems.item(i).classList.add("disabledDay");
               elems.item(i).getElementsByTagName("button")[0].classList.add("disabledDay");
            }
          } 
        });
        }
        this.updateMonthPicker();
      }
    },
  },
  mounted() {
    this.value = this.getCurrentGDate();
  },
  methods: {
    highlightGDate() {},
    highlightTodaysDate() {},
    setDate({ date }) {
      this.value = date;
      Calendar_SetFullDate(new Date(date.toString() + "T12:00:00-06:30"));
      Calendar_ReloadDash(new Date(sessionStorage.gDate));
    },
    setDateToToday() {
      var today = new Date();
      var finalDate =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      this.value =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate(); 
      Calendar_SetFullDate(new Date(finalDate));
      Calendar_ReloadDash(new Date(sessionStorage.gDate));
    },
    setDateToYesterday() {
      var today = new Date();
      var finalDate =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() - 1);
      this.value =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() - 1); 
      Calendar_SetFullDate(new Date(finalDate));
      Calendar_ReloadDash(new Date(sessionStorage.gDate));
    },
    updateMonthPicker() {
      var todaysMonth = new Date().getMonth(); 
      var todaysYear = new Date().getFullYear();
      if(!(parseInt(this.$refs.yearPicker.value) === todaysYear))
      {
        return;
      }
      if(this.$props.showFuture === true)
      {
        return;
      }
      // Disable future months by removing them from the options.
      // loop through all options in monthPicker and remove any option value > than todaysMonth variable.
      var length = this.$refs.monthPicker.options.length;
      for (var i = length - 1; i >= 0; i--) 
      {
               var month = parseInt(this.$refs.monthPicker.options[i].value);
               if(month > todaysMonth)
               {
                 this.$refs.monthPicker.options[i].style.display = "none";
               }
      }

    },
    updateYearPicker() {
      var yearPicker = this.$refs.yearPicker;
      var todaysDate = new Date();
      var todaysYear = todaysDate.getFullYear();

      var gDate = this.value;
      var currentYear = parseInt(gDate.split("-")[0]);
      var years = [];

      years.push(currentYear);

      for (var i = 0; i < this.$props.yearsBack; i++) {
        currentYear -= 1;
        years.push(currentYear);
      }

      currentYear += this.$props.yearsBack;

      for (var i = 0; i < this.$props.yearsForward; i++) {
        currentYear += 1;
        years.push(currentYear);
      }

      years.sort();

      var length = yearPicker.options.length;
      for (i = length - 1; i >= 0; i--) 
        yearPicker.options[i] = null;

      years.forEach((year) => {
        var option = document.createElement("option");
        if(this.showFuture === false && parseInt(year) > todaysYear)
        {
          var one = 1;
        } else
        {
        option.text = year;
        yearPicker.add(option);
        }
      });     
    },
    onMonthChange(event) {
      var month = (parseInt(event.target.value) + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      var splitDate = this.value.split("-");
      splitDate[1] = month;

      var newDate = splitDate[0] + "-" + splitDate[1] + "-" + splitDate[2];
      this.value = newDate;
    },
    onYearChange(event) {
      var currentDate = this.value;
      var newDate = currentDate.replace(
        this.value.substring(0, 4),
        event.target.value
      );
      this.value = newDate;

      var todaysDate = new Date();

      // re-enable all months.
      // Disable future months by removing them from the options.
      // loop through all options in monthPicker and remove any option value > than todaysMonth variable.
      var length = this.$refs.monthPicker.options.length;
      for (var i = length - 1; i >= 0; i--) 
      {
        this.$refs.monthPicker.options[i].style.display = "";       
      }

      // When showFuture is set to false, make sure that if user selects, for example, September 5, 2020, that when they change the year to today's year, 
      // they cannot make the date change to September 5, 2021 since that would be beyond today's date, assuming that today's date is April 13, 2021.
      if(this.$refs.yearPicker.value === todaysDate.getFullYear().toString() && this.$props.showFuture === false) {      
        this.$refs.monthPicker.selectedIndex =  todaysDate.getMonth() - 1;
        var year = todaysDate.getFullYear().toString();
        var month = (todaysDate.getMonth()+1).toString();
        if(month.length === 1) {
          month = "0" + month;
        }
        var day = "01";
        this.value = year + "-" + month + "-" + day;
      }
    },
    calendarMonthPrevious() {
      this.$refs.calendar.prev();
    },
    calendarMonthNext() {
      // check if we are in today's year. If so, only go next if our selected month is before today's month.
      if(this.$props.showFuture === false)
      {
        var todaysDate = new Date();
        var todaysMonth = todaysDate.getMonth();
        var todaysYear = todaysDate.getFullYear();
        var yearPicker = this.$refs.yearPicker.value;
        var monthPicker = this.$refs.monthPicker.value;
        if(parseInt(yearPicker) === todaysYear && parseInt(monthPicker) === todaysMonth)
        {
          return;
        }        
      }
      this.$refs.calendar.next();
    },
    getCurrentGDate() {
      var currentGDate = sessionStorage.getItem("gDate");
      var splitGDate = currentGDate.split("/");
      var month = splitGDate[0];
      var day = splitGDate[1];
      var year = splitGDate[2];

      if (month.length === 1) {
        month = "0" + month;
      }

      if (day.length === 1) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
  },
};
</script>
<style type="text/scss">
@import "../styles/psCalendarThemeBlue.scss";
@import "../styles/psCalendarThemeGray.scss";
</style>